module.exports = __webpack_public_path__ + "static/media/marker1.dc694960.png";